import { useReducer } from 'react';
import reducer from './reducer';
import { formInitialState } from './state';
export const useReducerState = () => {
    const [state, dispatch] = useReducer(reducer, formInitialState);
    return [state, dispatch];
};
//# sourceMappingURL=hooks.js.map